"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupName = void 0;
var GroupName;
(function (GroupName) {
    GroupName["DEVELOPERS"] = "Developers";
    GroupName["DESIGNERS"] = "Designers";
    GroupName["PRODUCT_MANAGERS"] = "Product Managers";
    GroupName["DATA_SPECIALISTS"] = "Data Specialists";
    GroupName["MARKETING"] = "Marketing";
    GroupName["OTHERS"] = "Others";
})(GroupName = exports.GroupName || (exports.GroupName = {}));
//# sourceMappingURL=GroupName.js.map